//
export default [
    'wh_item',
    'wh_product_upc_code',
    'wh_subfamily',
]